import { State } from '../combinedReducers';

export const userRoleSelector = (state: State) =>
  state.general.loggedUser?.role;
